const route = {
	path: ':codeCompany/roles',
	name: 'page-role',
	meta: {
		title: 'Roles',
	},
	props: true,
	component: () => import('@/pages/roles/page-role'),
	children: [
		{
			name: 'page-role-new',
			path: 'new',
			meta: {
				title: 'Nuevo Rol',
			},
			component: () => import('@/pages/roles/page-role-new'),
			props: true,
		},
		{
			name: 'page-role-edit',
			path: ':id/edit',
			meta: {
				title: 'Editar Rol',
			},
			component: () => import('@/pages/roles/page-role-new'),
			props: true,
		},
		{
			name: 'page-access-role',
			path: ':roleId/:roleName/access',
			meta: {
				title: 'Permisos',
			},
			component: () => import('@/pages/roles/page-role-access'),
			props: true,
		},
		{
			name: 'page-role-duplicate',
			path: ':id/duplicate',
			meta: {
				title: 'Duplicar Rol',
			},
			component: () => import('@/pages/roles/page-role-duplicate'),
			props: true,
		},
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/roles.js